import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  plannedMaintenanceTitle: {
    defaultMessage: '{providerDisplayName} might be unavailable',
    id: 'UnhealthyProvider.plannedMaintenanceTitle',
  },
  degradedTitle: {
    defaultMessage: 'We are currently experiencing problems with {providerDisplayName}',
    id: 'UnhealthyProvider.degradedTitle',
  },
  degradedBody: {
    defaultMessage:
      'You might be able to connect; if not, please try again later or select another bank',
    id: 'UnhealthyProvider.degradedBody',
  },
  degradedBodyPreselectedProvider: {
    defaultMessage: 'You might be able to connect; if not, please try again later',
    id: 'UnhealthyProvider.degradedBodyPreselectedProvider',
  },
  continueAnyway: {
    defaultMessage: 'Continue anyway',
    id: 'UnhealthyProvider.continueAnyway',
  },
  tryAnyway: {
    defaultMessage: 'Try anyway',
    id: 'UnhealthyProvider.tryAnyway',
  },
});
